export const SET_POS_TERMINAL = 'SET_POS_TERMINAL'
export const SET_POS_TERMINAL_LIST = 'SET_POS_TERMINAL_LIST'
export const SET_BLAZEPAY_PROCESSORS = 'SET_BLAZEPAY_PROCESSORS'
export const SET_DEJAVOO_SHOP_CONFIG = 'SET_DEJAVOO_SHOP_CONFIG'



// WEBPACK FOOTER //
// ./src/types/dejavoo.js